import React from 'react';
import { MuiThemeProvider, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import ChooseInterests from '../components/ChooseInterests';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import {theme} from "../App";
import Divider from '@material-ui/core/Divider';

interface Props {
  classes: any;
}

interface State {
  value: number;
}

class LandingView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: 0
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
  }
  handleChange = (event: any, value: number) => {
    this.setState({ value });
  }

  handleChangeIndex = (index: number) => {
    this.setState({ value: index });
  }

  render() {
    // const history = useHistory()
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline/>
        <Navbar page="landing" />
        <main className={classes.root}>
          <section>
            <Container maxWidth="md">
              <Typography variant="h3" color="textPrimary">
                Выбери свои интересы:
              </Typography>
              <ChooseInterests/>
              <br/>
              <Divider light />
              <br/>
              <Typography variant="h3" color="textPrimary">
                Как использовать сервис?
              </Typography>
              <br/>
              <Typography variant="body1" color="textPrimary">
                Выберите свои интересы и нажмите кнопку <b>Поиск</b>.
                Вы попадёте на страницу <b>Занятия</b> с результатами.
                Поиск осуществляется по базе занятий города,
                где у каждого занятия указано название,
                наименование организации дополнительного образования,
                краткое описание и соответствующие интересы.
                По нажатию на кнопку <b>Занятия</b> в правом-верхнем углу можно
                посмотреть полный список занятий.
              </Typography>
            </Container>
          </section>
        </main>
        <Footer/>
      </MuiThemeProvider>
    );
  }
}

const style = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "center",
      minWidth: 480,
      minHeight: "90vh",
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
    center: {
      display: "flex",
      justifyContent: "center",
    }
  }
);

export default withStyles(style)(LandingView);
